import { FirstImpressionsImageUrlsType } from '../../../../../model';
import {
  COMPASS,
  CONFLUENCE,
  FABRIC,
  JIRA_CORE,
  JIRA_PRODUCT_DISCOVERY,
  JSD,
  TEAM_CENTRAL,
  BEACON,
  JIRA_FAMILY,
  BITBUCKET
} from './constants';

export const getSocialProofProductLabel = (productKey: string) => {
  switch (productKey) {
    case 'jira-servicedesk.ondemand':
      return JSD;
    case 'confluence.ondemand':
      return CONFLUENCE;
    case 'jira-core.ondemand':
      return JIRA_CORE;
    case 'townsquare':
      return TEAM_CENTRAL;
    case 'jira-product-discovery':
      return JIRA_PRODUCT_DISCOVERY;
    case 'compass':
      return COMPASS;
    case 'atlassian-whiteboard':
      return FABRIC;
    case 'beacon':
      return BEACON;
    case 'jira':
      return JIRA_FAMILY;
    case 'com.atlassian.bitbucket':
      return BITBUCKET;
    default:
      return '';
  }
};

export const getSocialProofImageURLs = (
  productKey: string,
  firstImpressionsImageUrls: FirstImpressionsImageUrlsType
) => {
  switch (productKey) {
    case 'jira-servicedesk.ondemand':
      return {
        heroImage: firstImpressionsImageUrls.jiraServiceDesk.heroImage,
        logoImage: firstImpressionsImageUrls.jiraServiceDesk.socialProofImage
      };
    case 'confluence.ondemand':
      return {
        heroImage: firstImpressionsImageUrls.confluence.heroImage,
        logoImage: firstImpressionsImageUrls.confluence.socialProofImage
      };
    case 'jira-core.ondemand':
      return {
        heroImage: firstImpressionsImageUrls.jiraCore.heroImage,
        logoImage: firstImpressionsImageUrls.jiraCore.socialProofImage
      };
    case 'townsquare':
      return {
        heroImage: firstImpressionsImageUrls.teamCentral.heroImage,
        logoImage: firstImpressionsImageUrls.teamCentral.socialProofImage
      };
    case 'jira-product-discovery':
      return {
        heroImage: firstImpressionsImageUrls.jiraProductDiscovery.heroImage,
        logoImage:
          firstImpressionsImageUrls.jiraProductDiscovery.socialProofImage
      };
    case 'compass':
      return {
        heroImage: firstImpressionsImageUrls.compass.heroImage,
        logoImage: firstImpressionsImageUrls.compass.socialProofImage
      };
    case 'atlassian-whiteboard':
      return {
        heroImage: firstImpressionsImageUrls.fabric.heroImage,
        logoImage: firstImpressionsImageUrls.fabric.socialProofImage
      };
    case 'beacon':
      return {
        heroImage: firstImpressionsImageUrls.beacon.heroImage,
        logoImage: firstImpressionsImageUrls.beacon.socialProofImage
      };
    case 'jira':
      return {
        heroImage: firstImpressionsImageUrls.jira.heroImage,
        logoImage: firstImpressionsImageUrls.jira.socialProofImage
      };
    case 'com.atlassian.bitbucket':
      return {
        heroImage: firstImpressionsImageUrls.bitbucket.heroImage,
        logoImage: firstImpressionsImageUrls.bitbucket.socialProofImage
      };
    default:
      return {
        heroImage: firstImpressionsImageUrls.jiraSoftware.heroImage,
        logoImage: firstImpressionsImageUrls.jiraSoftware.socialProofImage
      };
  }
};
